import { render, staticRenderFns } from "./ChildrenGrandchildren.vue?vue&type=template&id=5a11105a"
import script from "./ChildrenGrandchildren.vue?vue&type=script&lang=js"
export * from "./ChildrenGrandchildren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports